import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import PropTypes from 'prop-types';
import { classNames, dayClassName } from '../../../containers/Pages/Edd/EddUtils';

function EddFilter(props) {
  const {
    showFilter,
    filterSearchField,
    handleFilterSearchFieldChange,
    playlistFilter,
    handleFileTypeChange,
    sequenceFilter,
    scheduleFilter,
    assignmentFilter,
    tagFilter,
    validStatusFilter,
    handleValidationStatusFilterChange,
    invalidStatusFilter,
    importedStatusFilter,
    handleImportStatusFilterChange,
    scheduledForImportStatusFilter,
    uploadedDateFilter,
    notImportedStatusFilter,
    handleUploadDateFilterChanged,
    customDateHeader,
    handleClearFilters,
    importedDateFilter,
    handleImportDateFilterChanged,
    handleSortColumnChangeFilter,
    handleSortOrderChangeFilter,
    sortOrderFilter,
    sortColumnFilter,
  } = props;
  const [showSortOptions, setShowSortOptions] = useState(false);
  const [sortOrderSelected, setSortOrderSelected] = useState(sortOrderFilter || null);
  const [sortColumnSelected, setSortColumnSelected] = useState(sortColumnFilter || null);

  useEffect(() => {
    setSortOrderSelected(sortOrderFilter || null);

    if (sortOrderFilter === null) {
      setSortColumnSelected(null);
    }
  }, [sortOrderFilter]);

  useEffect(() => {
    setSortColumnSelected(sortColumnFilter || null);
  }, [sortColumnFilter]);
  const [showFileTypeOptions, setShowFileTypeOptions] = useState(true);
  const [showValidationOptions, setShowValidationOptions] = useState(false);
  const [showImportStatusOptions, setShowImportStatusOptions] = useState(false);

  return (
    <div
      data-test="edd-filter-div"
      className={classNames(
        '-translate-x-full mt-8 transition-all duration-1000 w-72 flex items-center justify-center absolute',
        showFilter ? 'visible translate-x-0 opacity-100' : 'invisible opacity-0 absolute',
      )}
    >
      <div className="bg-white  w-64 pb-16   my-custom-shadow">
        <p className="ml-4 mt-3 font-bold ">Filters</p>

        <div className="flex items-center mt-4 border ml-4 mr-4 p-2">
          <img
            src="/assets/images/icons/search_input_icon_primary.svg"
            alt="search icon"
            className="w-[22px] h-[22px]"
          />
          <input
            data-test="edd-filter-search"
            className="ml-2 border-0 outline-none"
            placeholder="Search by file name..."
            value={filterSearchField}
            onChange={handleFilterSearchFieldChange}
          />
        </div>
        <div className="border-t mt-4  flex flex-col justify-center">
          <div className="flex ml-4 mr-8 justify-between items-center h-10">
            <p className="text-center flex justify-center items-center font-bold text-sm">
              File Type
            </p>
            <button
              type="button"
              data-test="edd-filter-file-type-toggle"
              onClick={() => {
                setShowFileTypeOptions(!showFileTypeOptions);
              }}
            >
              {showFileTypeOptions ? (
                <i className="material-icons !text-[24px] !text-primary  cursor-pointer  text-center  text-lg flex justify-center items-center duration-500 hover:scale-x-[115%] hover:scale-y-[115%]  transition-transform">
                  remove
                </i>
              ) : (
                <i className="material-icons !text-[24px] !text-primary  cursor-pointer  text-center  text-lg flex justify-center items-center duration-500 hover:scale-x-[115%] hover:scale-y-[115%]  transition-transform">
                  add
                </i>
              )}
            </button>
          </div>
          <div
            className={classNames(
              'transform duration-500 transition-all overflow-hidden bg-slate-50',
              showFileTypeOptions
                ? 'visible translate-y-0 opacity-100 max-h-96 pb-4'
                : 'max-h-0 invisible  -translate-y-[32px] opacity-0',
            )}
          >
            <div className="checkbox-wrapper-46 ml-8 mt-2">
              <input
                data-test="edd-filter-playlist"
                type="checkbox"
                id="cbx-46"
                className="inp-cbx"
                checked={playlistFilter}
                onChange={async () => {
                  await handleFileTypeChange('playlist');
                }}
              />
              <label htmlFor="cbx-46" className="cbx">
                <span>
                  <svg viewBox="0 0 12 10" height="10px" width="12px">
                    <polyline points="1.5 6 4.5 9 10.5 1" />
                  </svg>
                </span>
                <span className="text-sm font-normal">Playlist</span>
              </label>
            </div>

            <div className="checkbox-wrapper-46 ml-8 mt-2">
              <input
                data-test="edd-filter-sequence"
                type="checkbox"
                id="cbx-47"
                checked={sequenceFilter}
                className="inp-cbx"
                onChange={async () => {
                  await handleFileTypeChange('sequence');
                }}
              />
              <label className="cbx" htmlFor="cbx-47">
                <span>
                  <svg viewBox="0 0 12 10" height="10px" width="12px">
                    <polyline points="1.5 6 4.5 9 10.5 1" />
                  </svg>
                </span>
                <span className="text-sm font-normal">Sequence</span>
              </label>
            </div>
            <div className="checkbox-wrapper-46 ml-8 mt-2">
              <input
                data-test="edd-filter-schedule"
                type="checkbox"
                className="inp-cbx"
                id="cbx-48"
                checked={scheduleFilter}
                onChange={async () => {
                  await handleFileTypeChange('schedule');
                }}
              />
              <label className="cbx" htmlFor="cbx-48">
                <span>
                  <svg viewBox="0 0 12 10" height="10px" width="12px">
                    <polyline points="1.5 6 4.5 9 10.5 1" />
                  </svg>
                </span>
                <span className="text-sm font-normal">Schedule</span>
              </label>
            </div>
            <div className="checkbox-wrapper-46 ml-8 mt-2">
              <input
                data-test="edd-filter-assignment"
                type="checkbox"
                id="cbx-49"
                className="inp-cbx"
                checked={assignmentFilter}
                onChange={async () => {
                  await handleFileTypeChange('assignment');
                }}
              />
              <label className="cbx" htmlFor="cbx-49">
                <span>
                  <svg viewBox="0 0 12 10" height="10px" width="12px">
                    <polyline points="1.5 6 4.5 9 10.5 1" />
                  </svg>
                </span>
                <span className="text-sm font-normal">Assignment</span>
              </label>
            </div>
            <div className="checkbox-wrapper-46 ml-8 mt-2">
              <input
                data-test="edd-filter-tag"
                type="checkbox"
                id="cbx-50"
                className="inp-cbx"
                checked={tagFilter}
                onChange={async () => {
                  await handleFileTypeChange('tag');
                }}
              />
              <label className="cbx" htmlFor="cbx-50">
                <span>
                  <svg viewBox="0 0 12 10" height="10px" width="12px">
                    <polyline points="1.5 6 4.5 9 10.5 1" />
                  </svg>
                </span>
                <span className="text-sm font-normal">Tags</span>
              </label>
            </div>
          </div>
        </div>

        <div className="mt-0 flex flex-col justify-center border-t">
          <div className="flex ml-4 mr-8 justify-between items-center h-10">
            <p className=" h-[24px] text-center flex justify-center items-center font-bold text-sm">
              Validation Status
            </p>
            <button
              type="button"
              data-test="edd-filter-validation-options-toggle"
              onClick={() => {
                setShowValidationOptions(!showValidationOptions);
              }}
            >
              {showValidationOptions ? (
                <i className="material-icons !text-[24px] !text-primary  cursor-pointer  text-center  text-lg flex justify-center items-center duration-500 hover:scale-x-[115%] hover:scale-y-[115%]  transition-transform">
                  remove
                </i>
              ) : (
                <i className="material-icons !text-[24px] !text-primary  cursor-pointer  text-center  text-lg flex justify-center items-center duration-500 hover:scale-x-[115%] hover:scale-y-[115%]  transition-transform">
                  add
                </i>
              )}
            </button>
          </div>
          <div
            className={classNames(
              'transform duration-500 transition-all overflow-hidden bg-slate-50 bg-slate-50',
              showValidationOptions
                ? 'visible translate-y-0 opacity-100 max-h-96 pb-4'
                : 'max-h-0 invisible  -translate-y-[32px] opacity-0',
            )}
          >
            <div className="checkbox-wrapper-46 ml-8 mt-2">
              <input
                data-test="edd-filter-valid-status"
                type="checkbox"
                id="cbx-501"
                className="inp-cbx"
                checked={validStatusFilter}
                onChange={async () => {
                  await handleValidationStatusFilterChange('valid');
                }}
              />
              <label className="cbx" htmlFor="cbx-501">
                <span>
                  <svg viewBox="0 0 12 10" height="10px" width="12px">
                    <polyline points="1.5 6 4.5 9 10.5 1" />
                  </svg>
                </span>
                <span className="text-sm font-normal">Valid</span>
              </label>
            </div>
            <div className="checkbox-wrapper-46 ml-8 mt-2">
              <input
                data-test="edd-filter-invalid-status"
                type="checkbox"
                id="cbx-502"
                className="inp-cbx"
                checked={invalidStatusFilter}
                onChange={async () => {
                  await handleValidationStatusFilterChange('invalid');
                }}
              />
              <label className="cbx" htmlFor="cbx-502">
                <span>
                  <svg viewBox="0 0 12 10" height="10px" width="12px">
                    <polyline points="1.5 6 4.5 9 10.5 1" />
                  </svg>
                </span>
                <span className="text-sm font-normal">Invalid</span>
              </label>
            </div>
          </div>
        </div>
        <div className="border-t flex flex-col justify-center">
          <div className="flex ml-4 mr-8 justify-between items-center h-10">
            <p className=" h-[24px] text-center flex justify-center items-center font-bold text-sm">
              Import Status
            </p>
            <button
              type="button"
              data-test="edd-filter-import-status-toggle"
              onClick={() => {
                setShowImportStatusOptions(!showImportStatusOptions);
              }}
            >
              {showImportStatusOptions ? (
                <i className="material-icons !text-[24px] !text-primary  cursor-pointer  text-center  text-lg flex justify-center items-center duration-500 hover:scale-x-[115%] hover:scale-y-[115%]  transition-transform">
                  remove
                </i>
              ) : (
                <i className="material-icons !text-[24px] !text-primary  cursor-pointer  text-center  text-lg flex justify-center items-center duration-500 hover:scale-x-[115%] hover:scale-y-[115%]  transition-transform">
                  add
                </i>
              )}
            </button>
          </div>
          <div
            className={classNames(
              'transform duration-500 transition-all overflow-hidden bg-slate-50',
              showImportStatusOptions
                ? 'visible translate-y-0 opacity-100 max-h-96 pb-4'
                : 'max-h-0 invisible  -translate-y-[32px] opacity-0',
            )}
          >
            <div className="checkbox-wrapper-46 ml-8 mt-2">
              <input
                data-test="edd-filter-imported"
                type="checkbox"
                id="cbx-531"
                className="inp-cbx"
                checked={importedStatusFilter}
                onChange={async () => {
                  await handleImportStatusFilterChange('imported');
                }}
              />
              <label className="cbx" htmlFor="cbx-531">
                <span>
                  <svg viewBox="0 0 12 10" height="10px" width="12px">
                    <polyline points="1.5 6 4.5 9 10.5 1" />
                  </svg>
                </span>
                <span className="text-sm font-normal">Imported</span>
              </label>
            </div>
            <div className="checkbox-wrapper-46 ml-8 mt-2">
              <input
                data-test="edd-filter-not-imported"
                type="checkbox"
                id="cbx-532"
                className="inp-cbx"
                checked={notImportedStatusFilter}
                onChange={async () => {
                  await handleImportStatusFilterChange('not_imported');
                }}
              />
              <label className="cbx" htmlFor="cbx-532">
                <span>
                  <svg viewBox="0 0 12 10" height="10px" width="12px">
                    <polyline points="1.5 6 4.5 9 10.5 1" />
                  </svg>
                </span>
                <span className="text-sm font-normal">Not Imported</span>
              </label>
            </div>
            <div className="checkbox-wrapper-46 ml-8 mt-2">
              <input
                data-test="edd-filter-scheduled"
                type="checkbox"
                id="cbx-539"
                className="inp-cbx"
                checked={scheduledForImportStatusFilter}
                onChange={async () => {
                  await handleImportStatusFilterChange('scheduled_for_import');
                }}
              />
              <label className="cbx" htmlFor="cbx-539">
                <span>
                  <svg viewBox="0 0 12 10" height="10px" width="12px">
                    <polyline points="1.5 6 4.5 9 10.5 1" />
                  </svg>
                </span>
                <span className="text-sm font-normal">Scheduled For Import</span>
              </label>
            </div>
          </div>
        </div>

        <div className="mb-16 border-t flex flex-col justify-center border-b">
          <div className="flex ml-4 mr-8 justify-between h-10 items-center ">
            <p className=" h-[24px] text-center flex justify-center items-center font-bold">
              Sort Section
            </p>
            <button
              type="button"
              data-test="edd-filter-sort-options-toggle"
              onClick={() => {
                setShowSortOptions(!showSortOptions);
              }}
            >
              {showSortOptions ? (
                <i className="material-icons !text-[24px] !text-primary  cursor-pointer  text-center  text-lg flex justify-center items-center duration-500 hover:scale-x-[115%] hover:scale-y-[115%]  transition-transform">
                  remove
                </i>
              ) : (
                <i className="material-icons !text-[24px] !text-primary  cursor-pointer  text-center  text-lg flex justify-center items-center duration-500 hover:scale-x-[115%] hover:scale-y-[115%]  transition-transform">
                  add
                </i>
              )}
            </button>
          </div>

          <div
            className={classNames(
              'transform duration-500 transition-all overflow-hidden bg-slate-50',
              showSortOptions
                ? 'visible translate-y-0 opacity-100 max-h-96 pb-4'
                : 'max-h-0  -translate-y-[32px] opacity-0',
            )}
          >
            <div className="mt-4 ml-4">
              <p className="font-semibold text-sm">Sort Order</p>

              <div className="ml-8 mt-2">
                <div className="edd-filter-radio-group">
                  <label className="edd-filter-radio">
                    <input
                      type="radio"
                      name="sort-order"
                      value="asc"
                      checked={sortOrderSelected === 'asc'}
                      onChange={e => {
                        setSortOrderSelected('asc');

                        if (!sortColumnSelected) {
                          setSortColumnSelected('uploadedDate');
                        }

                        handleSortOrderChangeFilter(e.target.value);
                      }}
                    />
                    <span className=" text-sm font-medium">Ascending</span>
                  </label>
                  <label className="edd-filter-radio">
                    <input
                      type="radio"
                      name="sort-order"
                      value="desc"
                      checked={sortOrderSelected === 'desc'}
                      onChange={e => {
                        setSortOrderSelected('desc');

                        if (!sortColumnSelected) {
                          setSortColumnSelected('uploadedDate');
                        }

                        handleSortOrderChangeFilter(e.target.value);
                      }}
                    />
                    <span className=" text-sm font-medium">Descending</span>
                  </label>
                </div>
              </div>
            </div>

            <div className="mt-4 ml-4">
              <p className="font-semibold text-sm">Sort Column</p>

              <div className="ml-8 mt-2">
                <div className="edd-filter-radio-group">
                  <label className="edd-filter-radio">
                    <input
                      type="radio"
                      name="sort-column"
                      value="uploadedDate"
                      checked={sortColumnSelected === 'uploadedDate'}
                      onChange={e => {
                        setSortColumnSelected('uploadedDate');
                        handleSortColumnChangeFilter(e.target.value);
                      }}
                    />
                    <span className=" text-sm font-medium">Uploaded Date</span>
                  </label>
                  <label className="edd-filter-radio">
                    <input
                      type="radio"
                      name="sort-column"
                      value="modifiedDate"
                      checked={sortColumnSelected === 'modifiedDate'}
                      onChange={e => {
                        setSortColumnSelected('modifiedDate');
                        handleSortColumnChangeFilter(e.target.value);
                      }}
                    />
                    <span className=" text-sm font-medium">Modified Date</span>
                  </label>
                  <label className="edd-filter-radio" value="importedDate">
                    <input
                      type="radio"
                      value="importedDate"
                      name="sort-column"
                      checked={sortColumnSelected === 'importedDate'}
                      onChange={e => {
                        setSortColumnSelected('importedDate');
                        handleSortColumnChangeFilter(e.target.value);
                      }}
                    />
                    <span className="text-dark-night text-sm font-normal font-medium">
                      Import Date
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <p className="font-bold pl-4 mt-8 text-sm border-t pr-4 pt-1">Uploaded Date</p>
        <div className="edd flex justify-center mt-2">
          <DatePicker
            selected={uploadedDateFilter}
            onChange={date => handleUploadDateFilterChanged(date)}
            formatWeekDay={nameOfDay => nameOfDay.substr(0, 1)}
            dayClassName={dayClassName}
            renderCustomHeader={customDateHeader}
            popperPlacement="top"
            dateFormat="dd/MM/yyyy"
            className="form-control"
            timeIntervals={15}
            placeholderText="--:--"
            timeCaption="On time"
            onChangeRaw={() => {}}
            disabled={false}
            isClearable={() => {}}
          />
        </div>

        <p className="font-bold pl-4 mt-8 text-sm border-t pr-4 pt-1">Imported Date</p>
        <div className="edd flex justify-center mt-2">
          <DatePicker
            selected={importedDateFilter}
            onChange={date => handleImportDateFilterChanged(date)}
            formatWeekDay={nameOfDay => nameOfDay.substr(0, 1)}
            dayClassName={dayClassName}
            renderCustomHeader={customDateHeader}
            popperPlacement="top"
            dateFormat="dd/MM/yyyy"
            className="form-control"
            timeIntervals={15}
            placeholderText="--:--"
            timeCaption="On time"
            onChangeRaw={() => {}}
            disabled={false}
            isClearable={() => {}}
          />
        </div>

        <div className="flex justify-center mt-4 pb-4">
          <button
            type="button"
            className="clear text-sm"
            onClick={() => {
              setSortOrderSelected(null);
              setSortColumnSelected(null);
              setShowSortOptions(false);
              handleClearFilters();
            }}
          >
            Clear Filters
          </button>
        </div>
      </div>
    </div>
  );
}

EddFilter.propTypes = {
  showFilter: PropTypes.bool,
  filterSearchField: PropTypes.string,
  handleFilterSearchFieldChange: PropTypes.func,
  playlistFilter: PropTypes.bool,
  handleFileTypeChange: PropTypes.func,
  sequenceFilter: PropTypes.bool,
  scheduleFilter: PropTypes.bool,
  assignmentFilter: PropTypes.bool,
  tagFilter: PropTypes.bool,
  validStatusFilter: PropTypes.bool,
  handleValidationStatusFilterChange: PropTypes.func,
  invalidStatusFilter: PropTypes.bool,
  importedStatusFilter: PropTypes.bool,
  handleImportStatusFilterChange: PropTypes.func,
  scheduledForImportStatusFilter: PropTypes.bool,
  uploadedDateFilter: PropTypes.object,
  notImportedStatusFilter: PropTypes.bool,
  handleUploadDateFilterChanged: PropTypes.func,
  customDateHeader: PropTypes.func,
  handleClearFilters: PropTypes.func,
  importedDateFilter: PropTypes.object,
  handleImportDateFilterChanged: PropTypes.func,
  handleSortColumnChangeFilter: PropTypes.func,
  handleSortOrderChangeFilter: PropTypes.func,
  sortOrderFilter: PropTypes.string,
  sortColumnFilter: PropTypes.string,
};

export default EddFilter;
